export default __webpack_public_path__ + "e27d12a79dde5e320f954fd04c4b5ad9.svg";